/** @prettier */
import { List } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import ExchangeBettingModal from '@xanadu/ui-shared/components/ExchangeBettingModal';
import FuturesBettingModal from '@xanadu/ui-shared/components/FuturesBettingModal';
import {
  isFuturesOrPredictionsProduct,
  isFuturesProduct,
} from '@xanadu/ui-shared/modules/application/selectors';

import { updateSidebar as updateSidebarAct } from '../../modules/sidebar/actions';

const BettingModalWrapper = ({
  updateSidebar,
  unsubmittedOrders,
  unsubmittedOffers,
  isFutures,
  isFuturesOrPredictions,
}) => {
  const onAddToMultiple = () => {
    updateSidebar({
      content: 'multiples',
      visible: true,
    });
  };

  if (
    (isFuturesOrPredictions && !unsubmittedOrders.size) ||
    (!isFuturesOrPredictions && !unsubmittedOffers.size)
  ) {
    return null;
  }

  return isFuturesOrPredictions ? (
    <FuturesBettingModal useContracts={isFutures} offer={unsubmittedOrders.first()} />
  ) : (
    <ExchangeBettingModal offer={unsubmittedOffers.first()} onAddToMultiple={onAddToMultiple} />
  );
};

BettingModalWrapper.propTypes = {
  unsubmittedOrders: PropTypes.instanceOf(List).isRequired,
  unsubmittedOffers: PropTypes.instanceOf(List).isRequired,
  updateSidebar: PropTypes.func.isRequired,
  isFuturesOrPredictions: PropTypes.bool.isRequired,
  isFutures: PropTypes.bool.isRequired,
};

const mapDispatchToProps = {
  updateSidebar: updateSidebarAct,
};

function mapStateToProps(state) {
  return {
    unsubmittedOffers: state.get('unsubmittedOffers'),
    unsubmittedOrders: state.getIn(['portfolio', 'unsubmittedOrders']),
    isFuturesOrPredictions: isFuturesOrPredictionsProduct(state),
    isFutures: isFuturesProduct(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BettingModalWrapper);
